import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    regionExploracion: [],
  },

  getters: {
    getRegionExploracion: (state) => state.regionExploracion,
  },

  mutations: {
    SET_REGION_EXPLORACION(state, regionExploracion) {
      state.regionExploracion = regionExploracion;
    },
  },

  actions: {
    async fetchRegionExploracion({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/regionExploracion`)
        .then((response) => {
          commit('SET_REGION_EXPLORACION', response.data.data);
        });
    },

    async saveRegionExploracion(context, regionExploracion) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;

      await Promise.all(
        regionExploracion.map(async (region) => {
          const response = await axios.post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/regionExploracion`, region);
          return response;
        }),
      );
    },

    async updateRegionExploracion(_, regionExploracion) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${
            regionExploracion.fk_idHistoriaClinica
          }/regionExploracion/${
            regionExploracion.fk_idRegionExploracion}`,
          regionExploracion,
        );
    },
  },
};
